/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import MuiAlert from '@mui/material/Alert';
import type { AlertProps } from '@mui/material/Alert';
import Fade from '@mui/material/Fade';
import Snackbar from '@mui/material/Snackbar';
import { selectSnackbar } from 'cart-ui-react/src/autoshipState/selectors';
import { Typography } from '@mui/material';
import useCloseSnack from './useCloseSnack';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

const Desktop = () => {
  const { message, type } = useSelector(selectSnackbar);
  const closeSnack = useCloseSnack();
  const open = useMemo(() => Boolean(message && type), [message, type]);

  return (
    <Snackbar
      id='autoship-saved-mocha'
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      TransitionComponent={(props) => (
        <Fade
          {...props}
          timeout={{
            enter: 1000,
            exit: 1000,
          }}
          appear={open}
        />
      )}
      sx={{
        minWidth: '275px',
      }}
    >
      <Alert
        severity={type}
        onClose={closeSnack}
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          py: 0,
        }}
      >
        <Typography fontSize='15px'>{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default Desktop;
